import React from "react";

import { ReactComponent as ExcellenceLogo } from "../../../../assets/icons/excellence-logo.svg";

export function Header({leftBarOpened}) {
	
	return (
		<div className="leftSideHeader">

			{
				leftBarOpened ? (
					<div className={leftBarOpened ? "logo" : "logo is-hidden"}>
						<ExcellenceLogo />
					</div>	
				) : 
				(
					<div className="logo-closed-hidden" />
				)
			}
		</div>
	)
}
